export default "__VITE_ASSET__a3672d5f__"